import dataStore from '../../../data/data';

const SocketLandmarks = (socket, message = null) => {
  if (message?.landmarks) {
    dataStore.setState((_data) => ({
      ..._data,
      mediaprocessing: {
        ..._data.mediaprocessing,
        peer: {
          ..._data.mediaprocessing.peer,
          face: {
            ..._data.mediaprocessing.peer.face,
            cast: {
              ..._data.mediaprocessing.peer.face.cast,
              landmarks: {
                ..._data.mediaprocessing.peer.face.cast.landmarks,
                live: message.landmarks
              }
            }
          }
        }
      }
    }));
  };

  if (socket.__landmarkInterval) return;

  socket.__landmarkInterval = setInterval(() => {
    if (socket.readyState !== WebSocket.OPEN) return;

    const landmarks = dataStore.getState().mediaprocessing.vitruvian.face.cast.landmarks.live;

    if (!landmarks) return;

    socket.send(
      JSON.stringify({
        action: 'stream-landmarks',
        message: {
          landmarks,
        },
      })
    );
  }, 33);
};

export default SocketLandmarks;